// screens/HomeSecondaryBannerManagerScreen.tsx
import React, { FormEvent, useEffect, useState } from 'react';
import { HomeSecondaryBannerManagerUI } from './ui';
import { Banners } from 'src/model/Banners';
import useForm from 'src/hooks/useForm';
import validators from 'src/helpers/validators';
import { setLoading } from 'src/redux/loading/loadingSlice';
import { api } from 'src/services/api';
import { useDispatch } from 'react-redux';
import { BannerBasic, FormInputBannerSecondaryBanner } from '../../types';
import { BannerType } from 'src/model/BannerType';
import { toast } from 'react-toastify';

export interface NameFiles {
  [key: string]: string;
}

export const HomeSecondaryBannerManagerScreen: React.FC = () => {
  const [banners, setBanners] = useState<Banners[]>([]);
  const dispatch = useDispatch();
  //   const { loading } = useSelector(useLoading);
  const [formNameFilesSecondary, setFormNameFilesSecondary] = useState<{
    [key: string]: string;
  }>({});

  const getBanners = async (): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get<Banners[]>(
        '/banner/find-all/SECUDARY_HOME'
      );
      if (response.status === 200) {
        setBanners(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar banners:', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const {
    formData: formDataSecondary,
    formErrors: formErrorsSecondary,
    setErrors: setErrorsSecondary,
    onChangeFormInput: onChangeFormInputSecondary,
    isFormValid: isFormValidSecondary,
    resetForm: resetFormSecondary,
  } = useForm({
    initialData: {
      altTextSecondaryBanner: '',
      imageSecondaryBanner: '',
      linkSecondaryBanner: '',
    },
    validators: {
      altTextSecondaryBanner: [validators.required],
      imageSecondaryBanner: [validators.required],
      linkSecondaryBanner: [validators.required],
    },
  });

  const handleSubmitSecondary = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      if (isFormValidSecondary()) {
        dispatch(setLoading(true));
        const payload: BannerBasic = {
          altText:
            formDataSecondary[
              FormInputBannerSecondaryBanner.altTextSecondaryBanner
            ],
          image:
            formDataSecondary[
              FormInputBannerSecondaryBanner.imageSecondaryBanner
            ],
          link: formDataSecondary[
            FormInputBannerSecondaryBanner.linkSecondaryBanner
          ],
          privatetype: BannerType.SECUDARY_HOME,
        };

        const response = await api.post<Banners>('/banner', payload);
        if (response.status === 201 || response.status === 200) {
          getBanners();
          resetFormSecondary();
          setFormNameFilesSecondary({});
          toast.success('Dados salvos com sucesso!');
        } else if (response.status === 400) {
          const errorMessage =
            typeof response.data === 'string'
              ? response.data
              : JSON.stringify(response.data);
          toast.error(errorMessage);
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      let errorMessage =
        'Falha ao realizar o cadastro, tente novamente mais tarde';
      if (error.response && error.response.data) {
        errorMessage =
          typeof error.response.data === 'string'
            ? error.response.data
            : JSON.stringify(error.response.data);
      }
      toast.error(errorMessage);
      setErrorsSecondary({
        name: [errorMessage],
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleOnChangeFileInputSecurary =
    (inputName: string) =>
    (file: File | undefined): void => {
      // validate if file is image
      if (file && file.type.match(/image\/(jpg|jpeg|png|webp)/)) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64 = reader.result?.toString();
          if (base64) {
            setFormNameFilesSecondary({
              ...formNameFilesSecondary,
              [inputName]: file.name,
            });
            onChangeFormInputSecondary(inputName)('');
            onChangeFormInputSecondary(inputName)(base64);
          }
        };
      } else {
        setErrorsSecondary({
          [inputName]: ['O formato deve ser .jpg, .jpeg, .png ou .webp'],
        });
      }
    };

  //   const handleEditBanner = (id: string) => {
  //     console.log(id);
  //       const banner = banners.find((b) => b.id === id);
  //       if (banner) {
  //         setFormData({ image: banner.image, altText: banner.altText });
  //         setFormNameFiles({ image: banner.image });
  //         setEditingId(id);
  //       }
  //   };

  const handleRemoveBanner = async (id: string): Promise<void> => {
    dispatch(setLoading(true));
    try {
      const response = await api.get(`/banner/delete/${id}`);
      if (response.status === 200) {
        toast.success('Banner apagado com sucesso');
        getBanners();
      }
    } catch (error) {
      console.error('Erro ao apagar o Banner:', error);
      toast.error('Algo deu errado');
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    getBanners();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBanners();
    // eslint-disable-next-line
  }, []);
  return (
    <HomeSecondaryBannerManagerUI
      banners={banners}
      formData={formDataSecondary}
      formErrors={formErrorsSecondary}
      formNameFilesSecondary={formNameFilesSecondary}
      onSubmitRegister={handleSubmitSecondary}
      onChangeFormInput={onChangeFormInputSecondary}
      onChangeFormFileInput={handleOnChangeFileInputSecurary}
      //   onEditBanner={handleEditBanner}
      onRemoveBanner={handleRemoveBanner}
    />
  );
};
